module.exports = __webpack_public_path__ + "img/power.06786cea.png";